import type { FaireProductEntity } from "../../entity_types/product";

export const p_94d5iwtr3l: FaireProductEntity = {
  token: "p_94d5iwtr3l",
  type: "product",
  name: "Peppermint Mandarin Plant-Powered Lozenges",
  brandToken: "b_dsnudsdke8",
  brandName: "Essential Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/bf6a2bd3aa6a6f0bfeb85bb46ced20334152a27f45260df7150eba671f08c68e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d92e5f01946dc680a00dabb80debfb6ecf3055dd359425e5dbf20a4c9770271c.jpeg",
    "https://cdn.faire.com/fastly/3e181ef4f58e221c8cbade6006d053843c3e40d24660c837c27eb480f2a54c0f.jpeg",
    "https://cdn.faire.com/fastly/4b000af37107166d830446be841eb5c6f91cf07b3f97e174210293f15495e6f5.png",
    "https://cdn.faire.com/fastly/04f020d0f4f743f98812d985d0a580d0a2084fff779bb32b6793eac67dc94a70.jpeg",
    "https://cdn.faire.com/fastly/a9ea49ce0b3f089b054508a4d6498e7211c42012e6588cfbcbaf23fd81d5a6d5.jpeg",
  ],
  priceDollars: 9.63,
  description:
    "Peppermint Mandarin Plant-Powered Lozenges\n(formerly New Day Blend™)\nNow USDA Organic Certified, Gluten-Free Certified, Vegan Certified\n\nStart fresh with the bright zest of mandarin orange and the cooling crispness of peppermint in our Peppermint Mandarin Plant-Powered Lozenges. This uplifting fusion combines citrus and mint for a refreshing flavor that energizes your senses and supports everyday wellness.\n\n🍊 Mandarin Brightness – Sweet and zesty, mandarin provides a burst of citrus flavor while naturally offering antioxidant support.\n🌿 Refreshing Peppermint – Cool and invigorating, peppermint awakens the senses with its classic crispness and soothing qualities.\n\nCrafted with organic ingredients, this supportive hard candy is a delicious way to enjoy plant-powered refreshment—perfect for an afternoon pick-me-up, travel companion, or mindful daily treat.",
  tags: [],
  msrpDollars: 19.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:29.257Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
